import Icon from 'vue-awesome/components/Icon'

Icon.register({
  label_off_sharp: {
    paths: [
      {
        d: 'M22 12l-4.97-7H8.66l10.7 10.73zM2 4l1 1v14h14l2 2 1.41-1.41L3.44 2.62z'
      }
    ],
    width: '24',
    height: '24'
  }
})
